import React from 'react';
import Parser from 'html-react-parser';
import Avatar from '../common/Avatar';
import Username from '../common/Username';
import Moment from 'react-moment';
import Comments from '../common/Comments';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const NewsDetail = (props) => (
    <div>
        <div className="news-post" style={{backgroundImage: `url(${props.post.image})`}}> </div>
        <h1>{props.post.title}</h1>
        <div className="panel-adt">
            <h2>{props.chapters[props.post.chapter].game.title} News</h2>
            <div>
                <div className="avatar-img pull-left">
                    <Avatar image={props.post.article.author.avatar} rank={props.ranks[props.users[props.post.article.author].rank]} width="32" height="32" />
                </div>
                <Username user={props.users[props.post.article.author]} />
                <div className="avatar-date timestamp">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{props.post.article.created}</Moment></Tooltip>}>
                        <Moment fromNow>{props.post.article.created}</Moment>
                    </OverlayTrigger>
                </div>
            </div>
        </div>
        <div className="panel-adt">
            <div className="ql-snow">
                <div className="comment ql-editor">
                    {Parser(props.post.article.body)}
                </div>
            </div>
        </div>
        <Comments minSecurity="Public" item={`/news/${props.post.article.slug}`} />
    </div>

);

export default NewsDetail;


// WEBPACK FOOTER //
// ./src/News/NewsDetail.js